import { map, prop } from 'ramda';

import { compact, eq, path } from '../../../../helpers/compact';
import {
  getBarsSorted,
  getColorScaleAppend,
  getLegends,
  tickFormat,
  totalAmount,
} from './charts';

const getChart = (data) =>
  compact({
    title: path('primary.title', data),
    desc: path('primary.desc', data),
    tickFormat: tickFormat(data),
    totalAmount: totalAmount(data),
    colorScale: getColorScaleAppend(data),
    bars: getBarsSorted(data),
    legends: getLegends(data),
    linebreak: eq('linebreak', 'oui', false, prop('primary', data)),
  });

export const processBarChart = (data = []) => compact(map(getChart, data));
